import { useEffect } from 'react';
import { faqData, trackEvent, analyticsEvents } from '../../data/mock';

const setMeta = (selector, attrs) => {
  let el = document.querySelector(selector);
  if (!el) { el = document.createElement('meta'); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export const useHomeSeo = () => {
  useEffect(() => {
    document.title = 'Agrarflächen verkaufen | AgrarKapital – Fachmakler für Ackerland, Wald & Grünland';
    setMeta('meta[name="description"]', { name: 'description', content: 'Ackerland, Wald oder Grünland verkaufen? Kostenlose, diskrete Ersteinschätzung vom Fachmakler für Agrarflächen. Landkreis eingeben und Bewertung starten. Tel: 08161/18505-50' });
    setMeta('meta[property="og:title"]', { property: 'og:title', content: 'Agrarflächen verkaufen | AgrarKapital' });
    setMeta('meta[property="og:description"]', { property: 'og:description', content: 'Kostenlose, diskrete Ersteinschätzung für Ackerland, Wald und Grünland vom spezialisierten Fachmakler.' });

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        { '@type': 'Organization', '@id': 'https://agrarkapital.com/#organization', name: 'AgrarKapital', alternateName: 'Heinrichs Immobilien', url: 'https://agrarkapital.com', telephone: '08161/18505-50', email: 'info@agrarkapital.com',
          address: { '@type': 'PostalAddress', streetAddress: 'Rindermarkt 8', addressLocality: 'Freising', postalCode: '85354', addressCountry: 'DE' }, founder: { '@type': 'Person', name: 'Andreas Heinrichs' } },
        { '@type': 'WebSite', '@id': 'https://agrarkapital.com/#website', url: 'https://agrarkapital.com', name: 'AgrarKapital', publisher: { '@id': 'https://agrarkapital.com/#organization' } },
        { '@type': 'RealEstateAgent', '@id': 'https://agrarkapital.com/#realestate', name: 'AgrarKapital - Heinrichs Immobilien', telephone: '08161/18505-50', email: 'info@agrarkapital.com', address: { '@id': 'https://agrarkapital.com/#organization' }, areaServed: 'Deutschland' },
        { '@type': 'FAQPage', '@id': 'https://agrarkapital.com/#faq', mainEntity: faqData.map((f) => ({ '@type': 'Question', name: f.question, acceptedAnswer: { '@type': 'Answer', text: f.answer } })) }
      ]
    };
    let script = document.querySelector('script[data-home-schema]');
    if (!script) { script = document.createElement('script'); script.type = 'application/ld+json'; script.setAttribute('data-home-schema', '1'); document.head.appendChild(script); }
    script.textContent = JSON.stringify(schema);
    trackEvent(analyticsEvents.LP_VIEW);
    return () => { script.remove(); };
  }, []);
};
